import { render, staticRenderFns } from "./TaskSignature.vue?vue&type=template&id=ca37e07e&"
import script from "./TaskSignature.vue?vue&type=script&lang=ts&"
export * from "./TaskSignature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports